// Scripted practice-call simulation for the /start funnel's speaking branch.
// Fully static: the "AI translate" and "suggested reply" are canned, so the
// step costs nothing and cannot fail for anonymous visitors. Audio keys
// (audioKey) must match wasl/core/onboarding_audio.py's DEMO_CLIPS.

export const CALL_SIM = {
  partner: "يُوسُف",
  partnerEn: "Yusuf",
  intro:
    "This is how a practice call feels. Yusuf just sent a message to the call chat — you don't need to understand it yet. That's the point.",
  genderNote: "Real practice calls are always gender-matched.",
  exchanges: [
    {
      key: "pc1",
      audioKey: "pc1",
      arabic: "السَّلَامُ عَلَيْكُمْ، كَيْفَ حَالُكَ الْيَوْمَ؟",
      translation: "Peace be upon you — how are you today?",
      reply: {
        audioKey: "pcr1",
        arabic: "وَعَلَيْكُمُ السَّلَامُ، أَنَا بِخَيْرٍ وَالْحَمْدُ لِلَّهِ",
        translation: "And upon you peace — I'm well, praise be to Allah.",
      },
    },
    {
      key: "pc2",
      audioKey: "pc2",
      arabic: "مَا شَاءَ اللَّهُ! نُطْقُكَ جَمِيلٌ. مُنْذُ مَتَى تَتَعَلَّمُ الْعَرَبِيَّةَ؟",
      translation: "Mā shāʼ Allāh! Your pronunciation is beautiful. How long have you been learning Arabic?",
      reply: null, // the sim ends here — the CTA answers this one
    },
  ],
  outro:
    "In real calls this works with your voice: live transcription, AI translation of anything you don't catch, and a suggested reply when you're stuck — at any level of Arabic.",
};
